import styled from "styled-components";
import { Button } from "primereact/button";
import { theme } from "styles/theme";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  min-width: 0;
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  min-height: 44px;
  border: 0;
  background: transparent;
  color: ${theme.colors.textSecondary};
  font: inherit;
  font-weight: ${theme.fontWeights.medium};
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: ${theme.colors.textPrimary};
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.tertiary};
    outline-offset: 2px;
  }
`;

export const PageTitle = styled.h1`
  margin: 0;
  color: ${theme.colors.textPrimary};
  font-size: ${theme.fontSizes.large};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
  margin-left: auto;
`;

export const StyledButton = styled(Button)`
  && {
    background-color: ${theme.colors.tertiary};
    color: ${theme.colors.onTertiary};
    border: 1px solid ${theme.colors.tertiary};
  }
  padding: 0.75rem 1.25rem;
  min-height: 44px;
  gap: 0.5rem;

  .p-button-icon-left {
    margin-right: 0.5rem;
  }

  .p-button-icon-right {
    margin-left: 0.5rem;
  }

  &&:enabled:hover {
    background-color: ${theme.colors.tertiaryDark};
    border-color: ${theme.colors.tertiaryDark};
    color: ${theme.colors.onTertiary};
  }

  &&:enabled:focus {
    box-shadow: ${theme.colors.focusRing};
  }
`;
